import angular from "angular";

angular
    .module('app')
    .service('ErrorResponseParser', ['Notifier', function (Notifier) {

        this.parse = function (error) {


            if (error.status == 422) {

                let content = '<div class="text-left">';

                content += 'Указанные данные неверные <br>';

                let fields = Object.keys(error.data.errors);

                fields.forEach(function (field) {
                    let errors = error.data.errors[field];

                    content += '<div style="margin-bottom: 5px;">';

                    content += `<div>Ошибки по полю "${field}":</div>`;

                    errors.forEach(function (item) {
                        content += `<div style="padding-left: 15px">- ${item}</div>`;
                    });

                    content += '</div>';
                });

                content += '</div>';

                Notifier.error(content);
            }

            if (error.status == 500) {
                Notifier.error('Сбой системы. Повторите попытку или свяжитесь с администратором', 3);
            }

        }

    }]);
